import { useEffect } from 'react';
import { useNavigate } from 'react-router';

import { getRedirectToAttr } from '../utils/redirectToLogin';

import { RouteTo } from '../routes';

export const FallbackPage = () => {
    const navigate = useNavigate();
    const redirectPath = getRedirectToAttr() || RouteTo.Activations();

    useEffect(() => {
        navigate(redirectPath);
    }, []);

    return null;
};
